import { goto } from '$app/navigation';

export const handleHrefLink = function (e, href, options) {
  let newTab = false;
  // forces to use goto()
  const useGoto = options && options.useGoto

    //Helps with the right click to open a new tab
    if (e && (e.ctrlKey || e.metaKey)) {
      newTab = true;
    }

    e.stopPropagation();

    if (useGoto && !newTab) {
      goto(href);
    } else {
      window.open(href, newTab ? '_blank' : '_self');
    }
};